export class Path {
  public static readonly LOGIN = {
    GET_USER_DETAILS: "dec-login/get"
  };

  public static readonly DEVICE = {
    GET_LIST: "dec-device/list",
    GET_DEVICE: "dec-device/get",
    UPDATE_DEVICE: "dec-device/update",
    INSERT_DEVICE: "dec-device/insert",
    DOWNLOAD_LIST: "dec-device-download/task-runner"
  };

  public static readonly DEVICE_USER = {
    GET_LIST: "dec-device-user/list",
    GET_DEVICE_USER: "dec-device-user/get",
    UPDATE_DEVICE_USER: "dec-device-user/update",
    INSERT_DEVICE_USER: "dec-device-user/insert",
    DOWNLOAD_LIST: "dec-device-user-dn/task-runner",
    DELETE_USER:"dec-device-user/delete"
  };

  public static readonly BOOKING_ADJUSTMENT = {
    GET_LIST: "dec-adjustment/list",
    GET_DETAILS: "dec-adjustment/get",
    // INSERT: "announcement/insert",
    // UPDATE: "adjustment/untag-onhold",
    GET_CONSOLIDATOR_LIST: "dec-adjustment/filter-consolidator-list"
  };

  public static readonly WEB_USER = {
    GET_LIST: "dec-web-user/list",
    GET_WEB_USER: "dec-web-user/get",
    UPDATE_WEB_USER: "dec-web-user/update",
    INSERT_WEB_USER: "dec-web-user/insert",
    DELETE_USER: "dec-web-user/delete",
    DOWNLOAD_LIST: "dec-web-user-dn/task-runner"
  };
  
  public static readonly SECURITY_MATRIX = {
    GET_LIST: "dec-web-role/list",
    GET_ROLE: "dec-web-role-matrix/list",
    UPDATE_ROLE: "dec-web-role-matrix/update",
    GET_MODULE_GROUP: "dec-web-module-group/list"
  }

  public static readonly GATEPASS = {
    GET_LIST: "dec-gatepass/list",
    UPSERT: "dec-gatepass/upsert"
  }

  public static readonly DASHBOARD = {
    GET_LAST_UPDATED_DATE: "dec-rpt-util-sum/get-last-summary-date",

    GET_OVERSTAY_BY_PORT_CHART: "dec-rpt-overstay-dash/get-by-port-of-discharge",
    GET_OVERSTAY_BY_PORT_DETAILS: "dec-report-overstay/task-runner",
    GET_OVERSTAY_BY_DAYS_CHART: "dec-rpt-overstay-dash/get-by-number-days",
    GET_OVERSTAY_BY_DAYS_DETAILS: "dec-report-overstay/task-runner",
    GET_CONSOLIDATOR_FILTER: "dec-rpt-overstay-fltr/get-consolidators",
    GET_POD_FILTER: "dec-rpt-overstay-fltr/get-discharge-ports",

    GET_UNRELEASED_CHART: "dec-rpt-unrel-dash/get-by-number-days",
    GET_UNRELEASED_DETAILS: "dec-report-unreleased/task-runner",
    GET_UNRELEASED_CONSOLIDATOR_FILTER: "dec-rpt-unrel-fltr/get-consolidators",
    GET_UNRELEASED_MASTER_BL_FILTER: "dec-rpt-unrel-fltr/get-master-bl-numbers",
    GET_UNRELEASED_BOOKING_NUMBER_FILTER: "dec-rpt-unrel-fltr/get-booking-numbers",
    
    GET_RELEASED_CHART: "dec-rpt-released-dash/get-per-month",
    GET_RELEASED_DETAILS: "dec-report-released/task-runner",
    GET_RELEASED_CONSOLIDATOR_FILTER: "dec-rpt-released-fltr/get-consolidators",
    GET_RELEASED_BOOKING_NUMBER_FILTER: "dec-rpt-released-fltr/get-booking-numbers",
    GET_RELEASED_CONTAINER_FILTER: "dec-rpt-released-fltr/get-container-numbers",

  }

  public static readonly OVERSTAY_REPORT = {
    GET_CONSOLIDATOR_FILTER: "dec-rpt-overstay-fltr/get-consolidators",
    GET_POD_FILTER: "dec-rpt-overstay-fltr/get-discharge-ports",
    GET_BOOKING_NUMBER_FILTER: "dec-rpt-overstay-fltr/get-booking-numbers",
    GET_REPORT: "dec-report-overstay/task-runner"
  }

  public static readonly CARGO_TRACKING_SUMMARY_REPORT = {
    GET_CONSOLIDATOR_FILTER: "dec-rpt-ctrsum-fltr/get-consolidators",
    GET_MASTER_BL_NUMBER_FILTER: "dec-rpt-ctrsum-fltr/get-master-bl-numbers",
    GET_PORT_OF_LOADING_FILTER: "dec-rpt-ctrsum-fltr/get-loading-ports",
    GET_CONTAINER_NUMBER_FILTER: "dec-rpt-ctrsum-fltr/get-container-numbers",
    GET_STATUS_FILTER: "dec-rpt-ctrsum-fltr/get-sh-statuses",
    GET_REPORT: "dec-rpt-ctrsum/task-runner"
  }

  public static readonly CARGO_TRACKING_DETAIL_REPORT = {
    GET_CONSOLIDATOR_FILTER: "dec-rpt-ctrdtl-fltr/get-consolidators",
    GET_CONTAINER_NUMBER_FILTER: "dec-rpt-ctrdtl-fltr/get-container-numbers",
    GET_BOOKING_NUMBER_FILTER: "dec-rpt-ctrdtl-fltr/get-booking-numbers",
    GET_STATUS_FILTER: "dec-rpt-ctrdtl-fltr/get-statuses",
    GET_REPORT: "dec-report-ctr-detail/task-runner"
  }

  public static readonly STRIPPING_TALLY_SHEET = {
    GET_LIST: "dec-strip-tsheet/list",
    GET_DETAIL: "dec-strip-tsheet/print-stripping"
  };

  public static readonly IMAGE_DOWNLOAD = {
    GET_LIST: "dec-txn-image/list",
    GET_BOOKING_NUMBER_LIST: "dec-manifest/detail-list", // notice this is different from BOC API
  };

  public static readonly GENERIC = {
    GET_ROLES: "dec-web-role/list"
  }

  public static readonly MANIFEST_DETAIL = {
    GET_LIST: "dec-manifest/detail-list",
    GET_DETAILS: "dec-manifest/detail-get",
    GET_CONSOLIDATOR_FILTER: "dec-manifest/filter-consolidators",
    GET_BOOKING_STATUS_FILTER: "dec-manifest/filter-booking-status",
    DOWNLOAD_LIST: "dec-manifest-dtl-dn/task-runner"
  }
  
  public static readonly MANIFEST_HEADER = {
    GET_LIST: "dec-manifest/header-list",
    GET_BOOKING_LIST: "dec-manifest/detail-list",
    GET_DETAILS: "dec-manifest/header-get",
    GET_CONSOLIDATOR_FILTER: "dec-manifest/filter-consolidators",
    GET_POL_FILTER: "dec-manifest/filter-loading-ports",
    GET_POD_FILTER: "dec-manifest/filter-discharge-ports",
    GET_STATUS_FILTER: "dec-manifest/filter-is-active-for-manifest-header",
    DOWNLOAD_LIST: "dec-manifest-hdr-dn/task-runner"
  }

  public static readonly MASTER_BL = {
    GET_LIST: "dec-masterbl/list", // this is also used for details
    GET_CONSOLIDATOR_FILTER: "dec-masterbl/filter-consolidators",
    DOWNLOAD_LIST: "dec-masterbl-download/task-runner"
  }

  public static readonly PRIVACY_POLICY = {
    GET_PRIVACY_POLICY: "dec-data-privacy/get"
  }

  public static readonly BOOKING_STATUS_UPLOAD = {
    GET_LIST: "dec-upload-file-history/list",
    POST_FILE: "dec-bk-sts-upl/task-runner",
    DOWNLOAD_FILE: "dec-upload-file-history/download"
  }

  /// TODO: OLD

  public static readonly ACCOUNT_SETTINGS = {
    GET_LIST: "/host-app-setting/sync",
    SAVE_SETTINGS: "/host-app-setting/sync"
  };

  public static readonly ACCOUNT = {
    GET_LIST: "/principals"
  }

  public static readonly CHANNEL = {
    GET_LIST: "/channels"
  }

  public static readonly REGION = {
    GET_LIST: "/regions"
  }

  public static readonly ROLE = {
    GET_LIST: "/roles",
    ADD: "",
    UPDATE: ""
  }

  public static readonly STORE = {
    GET_LIST: "/stores",
    GET_DETAIL: "/stores",
    ADD: "/stores",
    UPDATE: "/stores",
    EXPORT: "/stores/export"
  }

  public static readonly TS = {
    GET_LIST: "/trade-supervisors"
  }

  public static readonly USER = {
    GET_LIST: "/users",
    GET_DETAIL: "/users",
    ADD: "/users",
    UPDATE: "/users",
    RESET_PASSWORD: "/users/reset-password",
    EXPORT: "/users/export"
  }

  public static readonly ATTENDANCE_REPORT = {
    GET_REPORT_DATA: "/report/attendance",
    EXPORT: "/report/attendance/export"
  }

  public static readonly RED_FLAG_REPORT = {
    GET_REPORT_DATA: "/report/red-flag",
    EXPORT: "/report/red-flag/export"
  }

  public static readonly RAW_DATA_REPORT = {
    GET_COUNT: "/raw-data",
    EXPORT: "/raw-data/export"
  }

}